import React, {Component} from 'react';

export default class ToasterSvgs extends Component {
    render() {
        return (
            <svg display="none" width="0" height="0" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <defs>
                    <symbol id="toast-x" viewBox="0 0 18 18">
                        <title>{'x'}</title>
                        <g transform="translate(1.000000, 1.000000)">
                            <path d="M0.444444444,0.444444444 L15.5293891,15.5293891" />
                            <path d="M15.5293891,0.444444444 L0.444444444,15.5293891" />
                        </g>
                    </symbol>
                </defs>
            </svg>
        );
    }
}